import { ErrorM } from "components/helpers";
import React from "react";
import { Input } from "./Input";

export interface FormTextFieldProps {
  field: string;
  label: string;
  required: boolean;
  type?: string;
  hint?: string;
  optionalTag?: string;
  disabled?: boolean;
  placeholder?: string;
  sideBySide?: boolean;
  isVisible?: boolean;
  maxLength?: number;
  icon?: string;
  showIcon?: boolean;
  onClickIcon?: () => void;
  touched?: () => void;
  labelChild?: React.ReactNode;
  autoFocus?: boolean;
  autoComplete?: string;
  className?: string;
  password?: boolean;
  asterisk?: boolean;
  inputMode?:
    | "none"
    | "text"
    | "tel"
    | "url"
    | "email"
    | "numeric"
    | "decimal"
    | "search";
  onBlur?: (e: React.FocusEvent) => void;
  inputProps?:
    | JSX.IntrinsicElements["input"]
    | JSX.IntrinsicElements["textarea"];
}

const FormTextField = React.forwardRef<HTMLInputElement, FormTextFieldProps>(
  (
    {
      field,
      label,
      required,
      type,
      hint,
      optionalTag,
      disabled,
      placeholder,
      sideBySide,
      isVisible = true,
      maxLength,
      icon,
      onClickIcon,
      showIcon = false,
      touched,
      labelChild,
      autoFocus = false,
      autoComplete = true,
      className = "",
      // Ideally shouldn't need this prop because the asterisk depends on whether the field
      // is required. However, there are plenty of forms in this project where the field are
      // required but it wouldn't make sense to show the asterisk and message.
      asterisk = false,
      onBlur,
      password,
      inputProps,
      inputMode,
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={`FormBox ${password && "PasswordField"} ${sideBySide &&
          "SideBySide"} ${isVisible ? "" : "Hide"}`}
      >
        <div className="FormLabel">
          {labelChild ? (
            labelChild
          ) : (
            <label>
              {label}
              {asterisk && <span>*</span>}
            </label>
          )}
          {hint && <div className="FormHint">{hint}</div>}
        </div>
        <div className="FormField">
          <Input
            name={field}
            type={type ? type : "text"}
            disabled={disabled}
            placeholder={placeholder}
            maxLength={maxLength}
            touched={touched}
            autoFocus={autoFocus}
            autoComplete={autoComplete}
            className={className}
            onBlur={onBlur}
            {...inputProps}
            ref={ref}
            inputMode={inputMode ?? undefined}
          />
          {showIcon && icon && <img src={icon} alt="" onClick={onClickIcon} />}
          <ErrorM name={field} />
        </div>
      </div>
    );
  }
);

export default FormTextField;
